var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMappinAirportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.673 5.00626C12.6125 4.78447 12.4669 4.5956 12.268 4.4808C12.0691 4.366 11.833 4.33456 11.611 4.39334L8.551 5.21357L4.555 1.5L3.448 1.79745L5.842 5.93465L2.971 6.7008L1.837 5.81748L1 6.04281L2.494 8.63871L12.052 6.07887C12.52 5.94367 12.79 5.46595 12.673 5.00626ZM18.1 8.68378L17.2 10.4865H12.7L11.8 8.68378L12.7 7.78242H14.5V5.97972H15.4V7.78242H17.2L18.1 8.68378ZM19 17.6973V19.5H1V17.6973H12.7V11.3878H17.2V17.6973H19Z",
    fill: "#1C3D5D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMappinAirportIcon);
export default __webpack_public_path__ + "static/media/mappin-airport-icon.6287e05d229d708e36ab6a682fa2ebee.svg";
export { ForwardRef as ReactComponent };